import {ROOT_URL, MAX_ERROR_TEXT_LEN} from '@/store';
// import store from '@/store';

const REQUEST_LINK = '/iapi_report/build_report_page/?page_uid=';

function buildReport(pageUid, formData, handler) {
  fetch(ROOT_URL + REQUEST_LINK + pageUid, {
    method: 'POST',
    credentials: 'include',
    body: JSON.stringify(formData),
  }).then(async function(response) {
    if (response.status == 200) {
      handler(await response.json());
      return;
    }

    if (response.status == 401) {
      const dsData = await response.json();

      const authResult = await window.openExtAuthWindow(dsData.uid, dsData.view);
      if (authResult == 'ok') {
        buildReport(pageUid, formData, handler);
        return;
      }

      handler({
        _error: true,
        status: response.status,
        text: 'Ошибка доступа к источнику. Неверный логин или пароль.',
      });
      return;
    }

    handler({
      _error: true,
      status: response.status,
      text: `Ошибка формирования отчета. ${(await response.text()).trimLen(MAX_ERROR_TEXT_LEN)}`,
    });
  }).catch((errData) => {
    console.log('errData', errData);
    handler({
      _error: true,
      status: null,
      text: 'Ошибка подключения к серверу',
    });
  });
}

export default buildReport;
